var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGooglePlayBadge = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 40,
    viewBox: "0 0 137 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.433 40H5.43323C2.63323 40 0.433228 37.8 0.433228 35V5C0.433228 2.2 2.63323 0 5.43323 0H130.433C133.233 0 135.433 2.2 135.433 5V35C135.433 37.7 133.233 40 130.433 40Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.433 0.8C132.733 0.8 134.633 2.7 134.633 5V35C134.633 37.3 132.733 39.2 130.433 39.2H5.43323C3.13323 39.2 1.23323 37.3 1.23323 35V5C1.23323 2.7 3.13323 0.8 5.43323 0.8H130.433ZM130.433 0H5.43323C2.63323 0 0.433228 2.2 0.433228 5V35C0.433228 37.8 2.63323 40 5.43323 40H130.433C133.233 40 135.433 37.8 135.433 35V5C135.433 2.3 133.233 0 130.433 0Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8332 10.2004C47.8332 11.0004 47.6332 11.7004 47.1332 12.2004C46.5332 12.8004 45.8332 13.1004 44.9332 13.1004C44.0332 13.1004 43.3332 12.8004 42.7333 12.2004C42.1333 11.6004 41.8333 10.9004 41.8333 10.0004C41.8333 9.10037 42.1333 8.40037 42.7333 7.80037C43.3332 7.20039 44.0332 6.90039 44.9332 6.90039C45.3332 6.90039 45.7333 7.00039 46.1332 7.20039C46.5332 7.40039 46.8332 7.60039 47.0332 7.90037L46.5332 8.40037C46.1333 7.90037 45.6332 7.70037 44.9332 7.70037C44.3332 7.70037 43.7333 7.90037 43.3333 8.40037C42.8333 8.80037 42.6333 9.40037 42.6333 10.1004C42.6333 10.8004 42.8333 11.4004 43.3333 11.8004C43.8333 12.2004 44.3332 12.5004 44.9332 12.5004C45.6332 12.5004 46.1332 12.3004 46.6332 11.8004C46.9332 11.5004 47.1332 11.1004 47.1332 10.6004H44.9332V9.90037H47.8332C47.8332 9.90037 47.8332 10.1004 47.8332 10.2004Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4332 7.70002H49.7332V9.60002H52.2332V10.3H49.7332V12.2H52.4332V13H48.9332V7H52.4332V7.70002Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7334 13H54.9334V7.70002H53.2334V7H57.4334V7.70002H55.7334V13Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3333 13V7H61.1333V13H60.3333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5333 13H63.7333V7.70002H62.0333V7H66.1333V7.70002H64.4333V13H64.5333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0333 12.2004C73.4333 12.8004 72.7333 13.1004 71.8333 13.1004C70.9333 13.1004 70.2333 12.8004 69.6333 12.2004C69.0333 11.6004 68.7333 10.9004 68.7333 10.0004C68.7333 9.1004 69.0333 8.4004 69.6333 7.8004C70.2333 7.20039 70.9333 6.90039 71.8333 6.90039C72.7333 6.90039 73.4333 7.20039 74.0333 7.8004C74.6333 8.4004 74.9333 9.1004 74.9333 10.0004C74.9333 10.9004 74.6333 11.6004 74.0333 12.2004ZM70.2333 11.7004C70.6333 12.1004 71.2333 12.4004 71.8333 12.4004C72.4333 12.4004 73.0333 12.2004 73.4333 11.7004C73.8333 11.3004 74.1333 10.7004 74.1333 10.0004C74.1333 9.3004 73.9333 8.7004 73.4333 8.3004C73.0333 7.9004 72.4333 7.60039 71.8333 7.60039C71.2333 7.60039 70.6333 7.8004 70.2333 8.3004C69.8333 8.7004 69.5333 9.3004 69.5333 10.0004C69.5333 10.7004 69.7333 11.3004 70.2333 11.7004Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0333 13V7H76.9331L79.8331 11.7V10.5V7H80.6331V13H79.8331L76.7333 8.10002V9.30002V13H76.0333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5332 21.7996C66.1332 21.7996 64.2332 23.5996 64.2332 26.0996C64.2332 28.4996 66.1332 30.3996 68.5332 30.3996C70.9332 30.3996 72.8332 28.5996 72.8332 26.0996C72.8332 23.4996 70.9332 21.7996 68.5332 21.7996ZM68.5332 28.5996C67.2332 28.5996 66.1332 27.4996 66.1332 25.9996C66.1332 24.4996 67.2332 23.3996 68.5332 23.3996C69.8332 23.3996 70.9332 24.3996 70.9332 25.9996C70.9332 27.4996 69.8332 28.5996 68.5332 28.5996ZM59.2332 21.7996C56.8332 21.7996 54.9332 23.5996 54.9332 26.0996C54.9332 28.4996 56.8332 30.3996 59.2332 30.3996C61.6332 30.3996 63.5332 28.5996 63.5332 26.0996C63.5332 23.4996 61.6332 21.7996 59.2332 21.7996ZM59.2332 28.5996C57.9332 28.5996 56.8332 27.4996 56.8332 25.9996C56.8332 24.4996 57.9332 23.3996 59.2332 23.3996C60.5332 23.3996 61.6332 24.3996 61.6332 25.9996C61.6332 27.4996 60.5332 28.5996 59.2332 28.5996ZM48.1332 23.0996V24.8996H52.4332C52.3332 25.8996 51.9332 26.6996 51.4332 27.1996C50.8332 27.7996 49.8332 28.4996 48.1332 28.4996C45.4332 28.4996 43.4332 26.3996 43.4332 23.6996C43.4332 20.9996 45.5332 18.8996 48.1332 18.8996C49.5332 18.8996 50.6332 19.4996 51.4332 20.1996L52.7332 18.8996C51.6332 17.8996 50.2332 17.0996 48.2332 17.0996C44.6332 17.0996 41.5332 20.0996 41.5332 23.6996C41.5332 27.2996 44.6332 30.2996 48.2332 30.2996C50.2332 30.2996 51.6332 29.6996 52.8332 28.3996C54.0332 27.1996 54.4332 25.4996 54.4332 24.1996C54.4332 23.7996 54.4332 23.3996 54.3332 23.0996H48.1332ZM93.5331 24.4996C93.1331 23.4996 92.133 21.7996 89.933 21.7996C87.733 21.7996 85.933 23.4996 85.933 26.0996C85.933 28.4996 87.733 30.3996 90.133 30.3996C92.033 30.3996 93.233 29.1996 93.633 28.4996L92.2331 27.4996C91.7331 28.1996 91.133 28.6996 90.133 28.6996C89.133 28.6996 88.533 28.2996 88.033 27.3996L93.733 24.9996L93.5331 24.4996ZM87.733 25.8996C87.733 24.2996 89.0331 23.3996 89.933 23.3996C90.633 23.3996 91.333 23.7996 91.533 24.2996L87.733 25.8996ZM83.0331 29.9996H84.933V17.4996H83.0331V29.9996ZM80.033 22.6996C79.533 22.1996 78.733 21.6996 77.7331 21.6996C75.6332 21.6996 73.6332 23.5996 73.6332 25.9996C73.6332 28.3996 75.5332 30.1996 77.7331 30.1996C78.733 30.1996 79.5331 29.6996 79.933 29.1996H80.033V29.7996C80.033 31.3996 79.133 32.2996 77.7331 32.2996C76.6332 32.2996 75.8332 31.4996 75.6332 30.7996L74.0332 31.4996C74.5332 32.5996 75.7332 33.9996 77.833 33.9996C80.033 33.9996 81.833 32.6996 81.833 29.5996V21.9996H80.033V22.6996ZM77.833 28.5996C76.5332 28.5996 75.4332 27.4996 75.4332 25.9996C75.4332 24.4996 76.5332 23.3996 77.833 23.3996C79.133 23.3996 80.133 24.4996 80.133 25.9996C80.133 27.4996 79.133 28.5996 77.833 28.5996ZM102.233 17.4996H97.733V29.9996H99.633V25.2996H102.233C104.333 25.2996 106.333 23.7996 106.333 21.3996C106.333 18.9996 104.333 17.4996 102.233 17.4996ZM102.333 23.4996H99.633V19.1996H102.333C103.733 19.1996 104.533 20.3996 104.533 21.2996C104.433 22.3996 103.633 23.4996 102.333 23.4996ZM113.833 21.6996C112.433 21.6996 111.033 22.2996 110.533 23.5996L112.233 24.2996C112.633 23.5996 113.233 23.3996 113.933 23.3996C114.933 23.3996 115.833 23.9996 115.933 24.9996V25.0996C115.633 24.8996 114.833 24.5996 114.033 24.5996C112.233 24.5996 110.433 25.5996 110.433 27.3996C110.433 29.0996 111.933 30.1996 113.533 30.1996C114.833 30.1996 115.433 29.5996 115.933 28.9996H116.033V29.9996H117.833V25.1996C117.633 22.9996 115.933 21.6996 113.833 21.6996ZM113.633 28.5996C113.033 28.5996 112.133 28.2996 112.133 27.4996C112.133 26.4996 113.233 26.1996 114.133 26.1996C114.933 26.1996 115.333 26.3996 115.833 26.5996C115.633 27.7996 114.633 28.5996 113.633 28.5996ZM124.133 21.9996L122.033 27.3996H121.933L119.733 21.9996H117.733L121.033 29.5996L119.133 33.7996H121.033L126.133 21.9996H124.133ZM107.333 29.9996H109.233V17.4996H107.333V29.9996Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 7.5C10.5333 7.79998 10.3333 8.29998 10.3333 8.89998V31C10.3333 31.6 10.5333 32.1 10.8333 32.4L10.9333 32.5L23.3333 20.1V20V19.9L10.8333 7.5Z",
    fill: "url(#paint0_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4332 24.2998L23.3333 20.1998V19.9998V19.8998L27.4332 15.7998L27.5332 15.8998L32.4332 18.6998C33.8332 19.4998 33.8332 20.7998 32.4332 21.5998L27.4332 24.2998Z",
    fill: "url(#paint1_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5333 24.2L23.3333 20L10.8333 32.5C11.3333 33 12.0333 33 12.9333 32.6L27.5333 24.2Z",
    fill: "url(#paint2_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5333 15.7996L12.9333 7.49962C12.0333 6.99962 11.3333 7.09962 10.8333 7.59962L23.3333 19.9996L27.5333 15.7996Z",
    fill: "url(#paint3_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.4333 24.0996L12.9333 32.2996C12.1333 32.7996 11.4333 32.6996 10.9333 32.2996L10.8333 32.3996L10.9333 32.4996C11.4333 32.8996 12.1333 32.9996 12.9333 32.4996L27.4333 24.0996Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M10.8332 32.3004C10.5332 32.0004 10.4332 31.5004 10.4332 30.9004V31.0004C10.4332 31.6004 10.6332 32.1004 10.9332 32.4004V32.3004H10.8332Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M32.4332 21.3L27.4332 24.1L27.5332 24.2L32.4332 21.4C33.1332 21 33.4332 20.5 33.4332 20C33.4332 20.5 33.0332 20.9 32.4332 21.3Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M12.9332 7.60037L32.4332 18.7004C33.0332 19.1004 33.4332 19.5004 33.4332 20.0004C33.4332 19.5004 33.1332 19.0004 32.4332 18.6004L12.9332 7.50037C11.5332 6.70037 10.4332 7.40037 10.4332 9.00035V9.10035C10.4332 7.50037 11.5332 6.80037 12.9332 7.60037Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 22.2329,
    y1: 8.70968,
    x2: 5.45057,
    y2: 25.4921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 34.2676,
    y1: 20.0012,
    x2: 10.0707,
    y2: 20.0012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 25.2603,
    y1: 22.2961,
    x2: 2.50192,
    y2: 45.0544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 7.73048,
    y1: 0.175819,
    x2: 17.8931,
    y2: 10.3383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGooglePlayBadge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-play-badge.0c79e9567fd9b83154155d9c14b5fe1e.svg";